import { useTabRouting } from 'App/Map/_utils/useTabRouting'
import { Admin } from 'App/Map/Admin/Admin'
import type { FC } from 'react'
import { lazy, Suspense } from 'react'
import { pushRoute } from 'utils/pushRoute'
import { Alerts } from '../../Shared/Alerts/Alerts'
import { ContactsAndGroups } from '../../Shared/ContactsAndGroups/ContactsAndGroups'
import { EmitterConfiguration } from '../../Shared/EmitterConfiguration/EmitterConfiguration'
import { EvapotranspirationSettings } from '../../Shared/EvapotranspirationSettings/EvapotranspirationSettings'
import { FertigationConfiguration } from '../../Shared/FertigationConfiguration/FertigationConfiguration'
import { IrrigationSchedulerSettings } from '../../Shared/IrrigationSchedulerSettings/IrrigationSchedulerSettings'
import { IrrigationReportsMain } from '../../Shared/ManageReports/IrrigationReports/IrrigationReportsMain'
import { ReportsMain } from '../../Shared/ManageReports/ReportsMain'
import { MyDetails } from '../../Shared/MyDetails'
import { Presets } from '../../Shared/Presets/Presets'
import { UnitSettings } from '../../Shared/UnitSettings'
import type { TSettingsItemProps } from '../../types'

const SemiosAPI = lazy(() =>
  import('../../Shared/SemiosAPI/SemiosAPI').then((m) => ({ default: m.SemiosAPI })),
)

export const SettingsItems: FC<TSettingsItemProps> = ({ currentTab, durationMillisecond, setCurrentTab }) => {
  useTabRouting(currentTab, pushRoute)

  return (
    <div
      css={{
        marginLeft: 400,
        backgroundColor: 'white',
        height: '100%',
        width: '100%',
      }}
    >
      {(() => {
        if (currentTab === 'mainMenu' || currentTab === 'myDetails') {
          return <MyDetails durationMillisecond={durationMillisecond} />
        }

        if (currentTab === 'contactsAndGroups') return <ContactsAndGroups />

        if (currentTab === 'unitSettings') return <UnitSettings durationMillisecond={durationMillisecond} />

        if (currentTab === 'presets') return <Presets />

        if (currentTab === 'semiosApi')
          return (
            <Suspense fallback={null}>
              <SemiosAPI />
            </Suspense>
          )

        if (currentTab === 'irrigationScheduler') return <IrrigationSchedulerSettings />

        if (currentTab === 'evapotranspiration') return <EvapotranspirationSettings />

        if (currentTab === 'alerts') return <Alerts />

        if (currentTab === 'reports') return <ReportsMain />

        if (currentTab === 'irrigationReports') return <IrrigationReportsMain />

        if (currentTab === 'emitterConfiguration') return <EmitterConfiguration />

        if (currentTab === 'fertigationConfiguration') return <FertigationConfiguration />

        if (currentTab === 'admin')
          return (
            <Suspense fallback={null}>
              <Admin setCurrentTab={setCurrentTab} />
            </Suspense>
          )

        return null
      })()}
    </div>
  )
}
